import { COUNTRY_LIST, MONTH_OPTIONS, REMARKS_OPTIONS } from '../../../../constants/index';
import { z } from 'zod'
import { NATURE_OF_REMITTANCE_OPTIONS_144 } from '@/constants/returnsNewFormAnnexure144'
// ALLOWED_PAN_STATUS constant for PAN validation
export const ALLOWED_PAN_STATUS = ['A', 'B', 'C', 'F', 'G', 'H', 'L', 'J', 'P', 'T'];

export const columns = [
  { id: 'ruleName', label: 'Rule name', minWidth: 100 },
  { id: 'mappedTdsSection', label: 'Mapped tds section', minWidth: 100 },
  { id: 'startDate', label: 'Start date', minWidth: 120 },
  { id: 'endDate', label: 'End date', minWidth: 120 },
  { id: 'status', label: 'Status', minWidth: 100 },
  { id: 'createdBy', label: 'Created by', minWidth: 150 },
  { id: 'createdAt', label: 'Created at', minWidth: 150 },
  { id: 'updatedBy', label: 'Updated by', minWidth: 150 },
  { id: 'updatedAt', label: 'Updated at', minWidth: 150 },
]


const ddMMYYYYWithSlash = z
  .string()
  .regex(
    /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
    "Invalid format. Example: 21/10/2024 (dd/mm/yyyy)"
  );


export const searchFieldsBackendMap = [
  { id: 'ruleName', label: 'Rule Name' },
  { id: 'mappedTdsSection', label: 'Mapped TDS Section' },
  { id: 'startDate', label: 'Start Date' },
  { id: 'endDate', label: 'End Date' },
  { id: 'active', label: 'Status' },
  { id: 'createdBy', label: 'Created By' },
  { id: 'createdDate', label: 'Created At' },
  { id: 'lastModifiedBy', label: 'Updated By' },
  { id: 'lastModifiedDate', label: 'Updated At' },
];

export const searchFields = [
  ...searchFieldsBackendMap.map(col => {
    if (col.id === 'startDate' || col.id === 'endDate' || col.id === 'createdDate' || col.id == 'lastModifiedDate') {
      return {
        ...col,
        type: 'text',
        placeholder: `Example: 24/11/2019 (dd/mm/yyyy)`,
        zod: ddMMYYYYWithSlash,
      };
    }

    // Default return
    return {
      id: col.id,
      label: col.label,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    };
  }),
];




const TRANSACTION_CATEGORIES = ['Invoice', 'Provision', 'Advance', 'Credit Note', 'Debit Note', 'Others'].map(v => ({ value: v, label: v }))
const VENDOR_STATUS_OPTIONS = ['Company', 'Other than company'].map(v => ({ value: v, label: v }))
const RESIDENTIAL_STATUS_OPTIONS = [{ value: 'R', label: 'Resident (R)' }, { value: 'NR', label: 'Non-Resident (NR)' }]
const YES_NO_OPTIONS = [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]
const TDS_RATE_TYPE_OPTIONS = [{ value: 'A', label: 'A' }, { value: 'B', label: 'B' }]

// Field options with inline validation config
export const fieldOptions = [
  {
    value: 'ENTITY_TAN',
    label: 'Entity TAN',
    dataType: 'text',
    validation: {
      isTanValidation: true,
      regex: /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/,
      maxLength: 10,
      error: 'Invalid TAN: Format must be 4 letters + 5 digits + 1 letter'
    }
  },
  {
    value: 'VENDOR_PAN',
    label: 'Vendor PAN',
    dataType: 'text',
    validation: {
      isPanValidation: true,
      maxLength: 10,
      error: 'Invalid PAN: Format must be 5 letters + 4 digits + 1 letter',
      allowSpecialPAN: ['PANNOTAVBL', 'PANINVALID', 'PANAPPLIED']
    }
  },
  { value: 'YEAR', label: 'Year', dataType: 'number', validation: { regex: /^(19\d{2}|20\d{2}|2100)$/, error: 'Year must be between 1900 and 2100', maxLength: 4 } },
  { value: 'MONTH', label: 'Month', dataType: 'dropdown', options: MONTH_OPTIONS },
  { value: 'POSTING_DATE', label: 'Posting Date', dataType: 'date' },
  { value: 'TRANSACTION_CATEGORY', label: 'Transaction Category', dataType: 'dropdown', options: TRANSACTION_CATEGORIES },
  { value: 'INVOICE_NO', label: 'Invoice No', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 50, error: 'All characters allowed except ^ and cannot exceed 50 Characters' } },
  { value: 'INVOICE_DATE', label: 'Invoice Date', dataType: 'date' },
  { value: 'ACCOUNTING_DOCUMENT_NO', label: 'Accounting Document No', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 50, error: 'All characters allowed except ^ and cannot exceed 50 Characters' } },
  { value: 'ACCOUNTING_DOCUMENT_DATE', label: 'Accounting Document Date', dataType: 'date' },
  { value: 'REFERENCE_NO', label: 'Reference No', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 50, error: 'All characters allowed except ^ and cannot exceed 50 Characters' } },
  {
    value: 'REFERENCE_DATE',
    label: 'Reference Date',
    dataType: 'date',
  },
  { value: 'DATE_OF_DEDUCTION', label: 'Date of Deduction', dataType: 'date' },
  { value: 'GROSS_EXPENSE_AMOUNT', label: 'Gross Expense Amount', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'TDS_BASE_AMOUNT', label: 'TDS Base Amount', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'TDS_SECTION', label: 'TDS Section', dataType: 'dropdown' },
  { value: 'TDS_RATE', label: 'TDS Rate', dataType: 'number', validation: { regex: /^[-+]?\d{1,3}(\.\d{1,2})?$/, error: 'Numeric only, up to 3 digits and 2 decimals', maxLength: 6 } },
  { value: 'TDS_AMOUNT', label: 'TDS Amount', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'SURCHARGE', label: 'Surcharge', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },

  {
    value: 'ACCOUNTING_DOC_TYPE',
    label: 'Accounting Doc. Type',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,10}$/,
      error: 'Max 10 characters allowed',
      maxLength: 10
    }
  },
  {
    value: 'DEBIT_CREDIT_INDICATOR',
    label: 'Debit/Credit Indicator',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,10}$/,
      error: 'Max 10 characters allowed',
      maxLength: 10
    }
  },
  {
    value: 'CANCELLED_FLAG',
    label: 'Cancelled Flag',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,10}$/,
      error: 'Max 10 characters allowed',
      maxLength: 10
    }
  },
  {
    value: 'TDS_ACCOUNT_GL_CODE',
    label: 'TDS Account GL Code',
    dataType: 'text',
    isFormatted: false,
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,100}$/,
      error: 'Max 100 characters allowed',
      maxLength: 100
    }
  },
  {
    value: 'OPERATING_UNIT',
    label: 'Operating Unit',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,75}$/,
      error: 'Max 75 characters allowed',
      maxLength: 75
    }
  },

  {
    value: 'PO_NO',
    label: 'PO No',
    dataType: 'text',
    isFormatted: false,
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,50}$/,
      error: 'Max 50 characters allowed',
      maxLength: 50
    }
  },


  {
    value: 'ENTRY_DATE',
    label: 'Entry Date',
    dataType: 'date'
  },
  {
    value: 'PROJECT_CODE',
    label: 'Project Code',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,30}$/,
      error: 'Max 30 characters allowed',
      maxLength: 30
    }
  }
  ,

  {
    value: 'CURRENCY',
    label: 'Currency',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,10}$/,
      error: 'Max 10 characters allowed',
      maxLength: 10
    }
  },

  {
    value: 'EXCHANGE_RATE',
    label: 'Exchange Rate',
    dataType: 'number',
    validation: {
      regex: /^\d{1,9}(\.\d{1,2})?$/,
      error: 'Exchange Rate must be a decimal with up to 9 digits and 2 decimals',
      maxLength: 12
    }
  },
  {
    value: 'EXCHANGE_TYPE',
    label: 'Exchange Type',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,10}$/,
      error: 'Max 10 characters allowed',
      maxLength: 10
    }
  },

  {
    value: 'OFFSET_GL_CODE',
    label: 'Offset GL Code',
    dataType: 'text',
    isFormatted: false,
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,100}$/,
      error: 'Max 100 characters allowed',
      maxLength: 100
    }
  },

  {
    value: 'TDS_ENTRY',
    label: 'TDS Entry',
    dataType: 'dropdown',
    options: [{ value: 'Y', label: 'Y' }, { value: 'N', label: 'N' }],
    validation: {
      error: 'Select Y or N'
    }
  },

  {
    value: 'WHT_TYPE',
    label: 'WHT Type',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,50}$/,
      error: 'Max 50 characters allowed',
      maxLength: 50
    }
  },
  {
    value: 'WHT_TAX_CODE',
    label: 'WHT Tax Code',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,50}$/,
      error: 'Max 50 characters allowed',
      maxLength: 50
    }
  },
  {
    value: 'SOURCE',
    label: 'Source',
    dataType: 'text',
    validation: {
      regex: /^[A-Za-z0-9\-_\/\s.,;:()&@#!$%*+=?|<>[\]{}"']{1,50}$/,
      error: 'Max 50 characters allowed',
      maxLength: 50
    }
  },
  {
    value: 'DUPLICATE_REFERENCE_NUMBER',
    label: 'Duplicate Reference Number',
    dataType: 'text',
    validation: {
      // Allow all characters (including the caret '^') up to 2000 chars.
      regex: /^[\s\S]{1,2000}$/,
      maxLength: 2000,
      error: 'All characters allowed and cannot exceed 2000 Characters'
    }
  },
  { value: 'EDUCATION_CESS', label: 'Education Cess', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'TOTAL_TDS_LIABILITY', label: 'Total TDS Liability', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'INTEREST', label: 'Interest', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'OTHERS', label: 'Others', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'PO_DESCRIPTION', label: 'PO Description', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 500, error: 'All characters allowed except ^ and cannot exceed 500 Characters' } },
  { value: 'NARRATION', label: 'Narration', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 500, error: 'All characters allowed except ^ and cannot exceed 500 Characters' } },
  { value: 'EXPENSE_GL_DESCRIPTION', label: 'Expense GL Description', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 500, error: 'All characters allowed except ^ and cannot exceed 500 Characters' } },
  { value: 'INVOICE_DESCRIPTION', label: 'Invoice Description', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 500, error: 'All characters allowed except ^ and cannot exceed 500 Characters' } },
  {
    value: 'HSN_CODE',
    label: 'HSN Code',
    dataType: 'number',
    validation: {
      regex: /^\d{1,8}$/,
      error: 'HSN Code must be numeric and between 1 to 8 digits',
      minLength: 1,
      maxLength: 8
    }
  },
  { value: 'GL_CODE', label: 'GL Code', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 100, error: 'All characters allowed except ^ and cannot exceed 100 Characters' } },
  { value: 'VENDOR_NAME', label: 'Vendor Name', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 75, error: 'All characters allowed except ^ and cannot exceed 75 Characters' } },
  { value: 'VENDOR_STATUS', label: 'Vendor Status', dataType: 'dropdown', options: VENDOR_STATUS_OPTIONS },
  { value: 'RESIDENTIAL_STATUS', label: 'Residential Status', dataType: 'dropdown', options: RESIDENTIAL_STATUS_OPTIONS },
  { value: 'TIN_UIN', label: 'TIN/UIN', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 26, error: 'All characters allowed except ^ and cannot exceed 26 Characters' } },
  { value: 'VENDOR_COUNTRY', label: "Vendor's Country of residence", dataType: 'dropdown', options: COUNTRY_LIST.filter((cy) => cy.id != 'Select') },
  { value: 'VENDOR_EMAIL', label: 'Vendor Email ID', dataType: 'email' },
  { value: 'VENDOR_CONTACT', label: 'Vendor Contact number', dataType: 'number', validation: { regex: /^\d{10,15}$/, error: 'Numeric only, min 10 and max 15 digits', maxLength: 15 } },
  { value: 'VENDOR_ADDRESS', label: 'Vendor Address', dataType: 'text', validation: 
    { regex: /^[^^]*$/, maxLength: 150, error: 'All characters allowed except ^ and cannot exceed 150 Characters' }
  },
  { value: 'VENDOR_REFERENCE_NO', label: 'Vendor Reference No. Provided by the Deductor (if available)', dataType: 'text', validation: { regex: /^[A-Za-z0-9]*$/, maxLength: 26, error: 'Alphanumeric only and cannot exceed 26 Characters' } },
  { value: 'VENDOR_PAN_AADHAR', label: 'Vendor PAN linking with Aadhar', dataType: 'dropdown', options: YES_NO_OPTIONS },
  { value: 'GROSSING_UP_INDICATOR', label: 'Grossing up Indicator', dataType: 'dropdown', options: YES_NO_OPTIONS },
  { value: 'NATURE_OF_REMITTANCE', label: 'Nature of Remittance', dataType: 'dropdown', options: NATURE_OF_REMITTANCE_OPTIONS_144 },
  { value: 'TDS_RATE_ACT_OR_DTAA', label: 'TDS rate belongs to IT Act or DTAA', dataType: 'dropdown', options: TDS_RATE_TYPE_OPTIONS },
  { value: 'REMARKS', label: 'Remarks (Reason for non-deduction / Lower deduction/ higher deduction/ threshold)', dataType: 'dropdown', options: REMARKS_OPTIONS },
  { value: 'CERTIFICATE_NO', label: 'Certificate number issued by the Assessing Officer u/s 197 for non-deduction/ lower deduction', dataType: 'text', validation: { regex: /^[A-Za-z0-9]*$/, maxLength: 10, error: 'Alphanumeric only and cannot exceed 10 Characters' } },
  { value: 'CHALLAN_SERIAL_NO', label: 'Challan Serial No', dataType: 'number', validation: { regex: /^\d{1,9}$/, error: 'Numeric only and up to 9 digits', maxLength: 9} },
  { value: 'BSR_CODE', label: 'BSR Code', dataType: 'number', validation: { regex: /^\d{7}$/, error: 'Numeric only and must be exactly 7 digits', maxLength: 7 } },
  { value: 'DATE_OF_TAX_DEPOSITED', label: 'Date of Tax Deposited', dataType: 'date' },
  { value: 'TOTAL_TAX_DEPOSITED', label: 'Total Tax Deposited', dataType: 'number', validation: { regex: /^[-+]?\d{1,12}(\.\d{1,2})?$/, error: 'Numeric only, up to 12 digits and 2 decimals', maxLength: 15 } },
  { value: 'PAID_BY', label: 'Paid by book entry or otherwise', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 50, error: 'All characters allowed except ^ and cannot exceed 50 Characters' } },
  { value: 'ACCOUNTING_YEAR', label: 'Accounting Year', dataType: 'number', validation: { regex: /^(19\d{2}|20\d{2}|2100)$/, error: 'Year must be between 1900 and 2100', maxLength: 4 } },
  { value: 'ACCOUNTING_MONTH', label: 'Accounting Month', dataType: 'dropdown', options: MONTH_OPTIONS },
  { value: 'PROVISION_ADJUSTMENT_REF_NO', label: 'Provision Adjustment Ref. No.', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 50, error: 'All characters allowed except ^ and cannot exceed 50 Characters' } },
  { value: 'ADVANCE_ADJUSTMENT_REF_NO', label: 'Advance Adjustment Ref. No.', dataType: 'text', validation: { regex: /^[^^]*$/, maxLength: 50, error: 'All characters allowed except ^ and cannot exceed 50 Characters' } },
  ...Array.from({ length: 20 }, (_, i) => ({
    value: `MIS_${i + 1}`,
    label: `MIS ${i + 1}`,
    dataType: 'text',
    validation: {
      regex: /^.{0,200}$/,
      maxLength: 200,
      error: 'All characters allowed and cannot exceed 200 Characters'
    }
  })),
  ...Array.from({ length: 20 }, (_, i) => {
    const num = String(i + 1).padStart(2, '0');
    const isFU01 = num === '01';
    return {
      value: `FU_${num}`,
      label: `FU_${num}`,
      dataType: 'text',
      validation: {
        regex: isFU01 ? /^[^^]*$/ : /^.{0,200}$/,
        maxLength: 200,
        error: isFU01
          ? 'Alphanumeric and special characters allowed except ^ and cannot exceed 200 Characters'
          : 'All characters allowed and cannot exceed 200 Characters'
      }
    };
  }),

]


export const operatorOptions = [
  { value: 'EQUAL_TO', label: 'Equal To' },
  { value: 'NOT_EQUAL_TO', label: 'Not Equal To' },
  { value: 'LIKE', label: 'CONTAINS' },
  { value: 'IS_NULL', label: 'Is Null' },
  { value: 'IS_NOT_NULL', label: 'Is Not Null' },
  { value: 'IN_LIST', label: 'In List (Excel word)' },
  { value: 'NOT_IN_LIST', label: 'NOT In List  (Excel word)' },
  { value: 'STARTS_WITH', label: 'Starts With' },
  { value: 'ENDS_WITH', label: 'Ends With' },
  { value: 'IN_LIST_PROBABLE_MATCH', label: 'In List (Contains Probable Match)' },
  { value: 'NOT_IN_LIST_PROBABLE_MATCH', label: 'NOT In List (Contains Probable Match)' },
  { value: 'GREATER_THAN', label: 'Greater Than' },
  { value: 'LESS_THAN', label: 'Less Than' },
  { value: 'BETWEEN', label: 'Between' },
  { value: 'GREATER_THAN_OR_EQUAL_TO', label: 'Greater Than Or Equal To' },
  { value: 'LESS_THAN_OR_EQUAL_TO', label: 'Less Than Or Equal To' },
]

// Helper function to validate PAN
export const validatePAN = (value) => {
  const valueStr = String(value || '').trim().toUpperCase();

  // Accept special PAN values without syntax validation
  const specialPANs = ['PANNOTAVBL', 'PANINVALID', 'PANAPPLIED'];
  if (specialPANs.includes(valueStr)) {
    return { isValid: true, error: null };
  }

  // Check if value is empty
  if (!valueStr) {
    return { isValid: false, error: 'PAN is required' };
  }

  // Check format: 5 letters + 4 digits + 1 letter
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  if (!panRegex.test(valueStr)) {
    return { isValid: false, error: 'Invalid PAN: Format must be 5 letters + 4 digits + 1 letter' };
  }

  // Check 4th character against allowed PAN status
  const fourthChar = valueStr.charAt(3);
  if (!ALLOWED_PAN_STATUS.includes(fourthChar)) {
    return {
      isValid: false,
      error: `4th character must be one of: ${ALLOWED_PAN_STATUS.join(', ')}`
    };
  }

  return { isValid: true, error: null };
};

export const validateTAN = (value) => {
  const valueStr = String(value || '').trim().toUpperCase();

  // Check if value is empty
  if (!valueStr) {
    return { isValid: false, error: 'TAN is required' };
  }

  // Check format: 5 letters + 4 digits + 1 letter
  const panRegex = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
  if (!panRegex.test(valueStr)) {
    return { isValid: false, error: 'Invalid TAN: Format must be 4 letters + 5 digits + 1 letter' };
  }

  return { isValid: true, error: null };
};

// Helper function to get field input configuration
export const getFieldInputConfig = (selectedField) => {
  const field = fieldOptions.find(f => f.value === selectedField)

  if (!field) {
    return {
      inputType: 'text',
      placeholder: 'Enter value',
      options: null,
      validation: null
    }
  }

  return {
    inputType: field.dataType,
    placeholder: `Enter ${field.label}`,
    options: field.options || null,
    validation: field.validation || null,
    maxLength: field.validation?.maxLength,
    pattern: field.validation?.regex,
  }
}